import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/cn';

/**
 * Status-Badge im shadcn-Look (ADR 0019): rounded-md, 12 px, font-medium —
 * kein Uppercase-Pill mehr. Farbige Tones nur für Status (§2.3), `outline`
 * für neutrale Meta-Angaben (z. B. KPI-Trends). Farbe nie allein — immer
 * mit Text (§2.3). Icons werden automatisch auf 12 px gesetzt.
 */
const badge = cva(
  'inline-flex w-fit shrink-0 items-center gap-1 whitespace-nowrap rounded-md border px-2 py-0.5 ' +
    "text-xs font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-3",
  {
    variants: {
      tone: {
        neutral: 'border-transparent bg-muted text-muted-foreground',
        accent: 'border-transparent bg-accent text-foreground',
        success: 'border-transparent bg-success-50 text-success-500',
        warning: 'border-transparent bg-warning-50 text-warning-500',
        danger: 'border-transparent bg-danger-50 text-danger-500',
        info: 'border-transparent bg-info-50 text-info-500',
        outline: 'border-border bg-background text-foreground',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badge> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badge({ tone }), className)} {...props} />;
}
